"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgCar2 = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { fill: "", fillRule: "evenodd", d: "M6 17.083a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667m2.279-1.832 8.278-.001a2.331 2.331 0 0 1 4.553 0H22v-2.709a.875.875 0 0 0-.875-.875h-3.667a.5.5 0 0 1-.447-.276L15.316 8h-8.09L5.53 11.39a.5.5 0 0 1-.447.276H3.708a.875.875 0 0 0-.875.875v2.709h.891a2.331 2.331 0 0 1 4.555.001m10.554 1.832a1.334 1.334 0 1 0 0-2.668 1.334 1.334 0 0 0 0 2.668M1.417 15.25h.416v-2.709c0-1.035.84-1.875 1.875-1.875h1.066l1.696-3.39A.5.5 0 0 1 6.917 7h8.708a.5.5 0 0 1 .447.276l1.696 3.39h3.357c1.035 0 1.875.84 1.875 1.875v3.209a.5.5 0 0 1-.5.5h-1.39a2.331 2.331 0 0 1-4.553 0H8.279a2.331 2.331 0 0 1-4.555 0H1.417a.5.5 0 0 1 0-1m11.917-6.416h.917a.5.5 0 0 1 .447.276l.915 1.833a.5.5 0 1 1-.893.447l-.78-1.556h-.606a.5.5 0 0 1 0-1", clipRule: "evenodd" })));
const ForwardRef = (0, react_1.forwardRef)(SvgCar2);
exports.default = ForwardRef;
